
import React from 'react'

const UsersIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7.4974" cy="4.99935" r="3.33333" fill-opacity="0.54" fill="#2B2B2B"/>
            <ellipse cx="7.4974" cy="14.1673" rx="5.83333" ry="3.33333" fill-opacity="0.54" fill="#2B2B2B"/>
            <path
                d="M17.4977 14.1664C17.4977 15.5471 15.8014 16.6664 13.7303 16.6664C14.3405 15.9995 14.76 15.1623 14.76 14.1676C14.76 13.1717 14.3395 12.3338 13.7282 11.6665C15.7992 11.6665 17.4977 12.7857 17.4977 14.1664Z"
                fill="#2B2B2B" fill-opacity="0.54"/>
            <path
                d="M14.9977 5C14.9977 6.38071 13.8784 7.5 12.4977 7.5C12.1966 7.5 11.9079 7.44678 11.6406 7.34923C12.0349 6.65582 12.26 5.85374 12.26 4.99907C12.26 4.14503 12.0352 3.3435 11.6415 2.65045C11.9086 2.5531 12.1969 2.5 12.4977 2.5C13.8784 2.5 14.9977 3.61929 14.9977 5Z"
                fill="#2B2B2B" fill-opacity="0.54"/>
        </svg>
    )
}

export default UsersIcon;